import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
	{
	  path: '/',
	  name: 'about',
	  component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
	},
	{
		path: '/manage',
		name: 'Manage',
		component: ()=>import('../views/Manage.vue'),
		redirect: { name: 'index' },
		children:[
			{
				path: 'stall-qualification',
				name: 'StallQualification',
				component: ()=>import('../views/StallQualification.vue'),
			},
			{
				path: 'index',
				name: 'index',
				component: ()=>import('../views/index.vue'),
			},
			{
				path: 'acidrollingcapacity',
				name: 'AcidrollingCapacity',
				component: ()=>import('../views/AcidrollingCapacity.vue'),
			},
			{
				path: 'acidrollingcapacity2',
				name: 'AcidrollingCapacity2',
				component: ()=>import('../views/AcidrollingCapacity2.vue'),
			},
			{
				path: 'acidrollingplan',
				name: 'AcidrollingPlan',
				component: ()=>import('../views/AcidrollingPlan.vue'),
			},
			{
				path: 'acidrollingactual',
				name: 'AcidrollingActual',
				component: ()=>import('../views/AcidrollingActual.vue'),
			},
			{
				path: 'promotion',
				name: 'Promotion',
				component: ()=>import('../views/Promotion.vue'),
			},{
				path: 'quanyi',
				name: 'Quanyi',
				component: ()=>import('../views/Quanyi.vue'),
			},
			{
				path: 'review',
				name: 'Review',
				component: ()=>import('../views/Review.vue'),
			},
			{
				path: 'stall-manage',
				name: 'StallManage',
				component: ()=>import('../views/StallManage.vue'),
			},
			{
				path: 'table-qrcode',
				name: 'TableQRCode',
				component: ()=>import('../views/TableQRCode.vue'),
			},
			{
				path: 'self-delivery',
				name: 'SelfDeliverySettings',
				component: ()=>import('../views/SelfDeliverySettings.vue'),
			},
			{
				path: 'pay-method',
				name: 'PayMethodSettings',
				component: ()=>import('../views/PayMethodSettings.vue'),
			},
			{
				path: 'billing',
				name: 'BillingManage',
				component: ()=>import('../views/BillingManage.vue'),
			},
			{
				path: 'promotion-activity',
				name: 'PromotionActivity',
				component: ()=>import('../views/PromotionActivity.vue'),
			},
			{
				path: 'coupon-batch',
				name: 'CouponBatch',
				component: ()=>import('../views/CouponBatch.vue'),
			},
			{
				path: 'fodSpec',
				name: 'FodSpec',
				component: ()=>import('../views/FodSpec.vue'),
			},
			{
				path: 'subaccounts',
				name: 'MerchantSubaccount',
				component: ()=>import('../views/MerchantSubaccount.vue'),
			}
		]
	}
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
	const user = JSON.parse(localStorage.getItem('user') || '{}')
	const userType = String(user.userType || '')
	if (to.name === 'StallQualification' && userType !== '4') {
		next('/manage/index')
		return
	}
	if (to.name === 'MerchantSubaccount' && userType !== '1') {
		next('/manage/index')
		return
	}
	if (userType === '5') {
		const allowedRoutes = ['index', 'AcidrollingCapacity', 'AcidrollingActual', 'AcidrollingPlan', 'FodSpec']
		if (to.name && !allowedRoutes.includes(to.name)) {
			next('/manage/index')
			return
		}
	}
	next()
})

export default router
